window.NovaleProductScriptVersion = 'variant-photo-sync-es5-2026-07-14';

(function () {
  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function pad2(value) {
    return String(value).length < 2 ? '0' + value : String(value);
  }

  function findVariantOptionByImageId(select, imageId) {
    var options = toArray(select.options);
    for (var index = 0; index < options.length; index += 1) {
      if (options[index].dataset.imageId === imageId && !options[index].disabled) {
        return options[index];
      }
    }
    return null;
  }

  function rootPath() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  function trackNovaleEvent(name, payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, novale: payload || {} });
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, payload || {});
    }
  }

  function updateVariantDisplay(select, syncImage) {
    var section = select.closest('[data-product-section]');
    var selectedOption = select.options[select.selectedIndex];
    var price = section && section.querySelector('[data-product-price]');
    var addPrice = section && section.querySelector('[data-add-price]');
    var selectedPrice = selectedOption ? selectedOption.dataset.price || '' : '';
    var imageId = selectedOption ? selectedOption.dataset.imageId || '' : '';
    var carousel = section && section.querySelector('[data-product-carousel]');

    if (price) price.textContent = selectedPrice;
    if (addPrice) addPrice.textContent = selectedPrice;

    if (syncImage && imageId && carousel && typeof carousel.nvShowImageById === 'function') {
      carousel.nvShowImageById(imageId, { syncVariant: false });
    }
  }

  document.addEventListener('change', function (event) {
    var select = event.target.closest('[data-variant-select]');
    if (!select) return;
    updateVariantDisplay(select, true);
  });

  toArray(document.querySelectorAll('[data-product-carousel]')).forEach(function (carousel) {
    var slides = toArray(carousel.querySelectorAll('[data-carousel-slide]'));
    var thumbnails = toArray(carousel.querySelectorAll('[data-carousel-thumbnail]'));
    var previous = carousel.querySelector('[data-carousel-previous]');
    var next = carousel.querySelector('[data-carousel-next]');
    var activeIndex = 0;

    if (slides.length < 2) return;

    function syncVariantToImage(imageId) {
      var section = carousel.closest('[data-product-section]');
      var select = section && section.querySelector('[data-variant-select]');
      var matchingOption = select && imageId ? findVariantOptionByImageId(select, imageId) : null;

      if (!select || !matchingOption || select.value === matchingOption.value) return;

      select.value = matchingOption.value;
      updateVariantDisplay(select, false);
    }

    function showSlide(index, options) {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach(function (slide, slideIndex) {
        var isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
      });
      thumbnails.forEach(function (thumbnail, thumbnailIndex) {
        var isActive = thumbnailIndex === activeIndex;
        thumbnail.classList.toggle('is-active', isActive);
        thumbnail.setAttribute('aria-selected', String(isActive));
      });

      if (!options || options.syncVariant !== false) {
        syncVariantToImage(slides[activeIndex] ? slides[activeIndex].dataset.imageId : '');
      }
    }

    carousel.nvShowImageById = function (imageId, options) {
      for (var index = 0; index < slides.length; index += 1) {
        if (slides[index].dataset.imageId === imageId) {
          showSlide(index, options);
          return;
        }
      }
    };

    if (previous) previous.addEventListener('click', function () { showSlide(activeIndex - 1); });
    if (next) next.addEventListener('click', function () { showSlide(activeIndex + 1); });
    thumbnails.forEach(function (thumbnail) {
      thumbnail.addEventListener('click', function () {
        showSlide(Number(thumbnail.dataset.slideIndex));
      });
    });
  });

  toArray(document.querySelectorAll('[data-variant-select]')).forEach(function (select) {
    updateVariantDisplay(select, true);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-card-product-form]');
    var button;
    var feedback;
    var originalLabel;

    if (!form) return;

    event.preventDefault();

    button = form.querySelector('[data-add-button]');
    feedback = form.querySelector('[data-add-feedback]');
    originalLabel = button ? button.textContent : '';

    if (!button || button.disabled) return;

    button.disabled = true;
    button.textContent = 'Adding...';
    if (feedback) feedback.textContent = '';

    fetch(form.action, {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add product');
        return fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (cartResponse) {
        if (!cartResponse.ok) throw new Error('Unable to refresh cart');
        return cartResponse.json();
      })
      .then(function (cart) {
        toArray(document.querySelectorAll('[data-cart-count]')).forEach(function (count) {
          count.textContent = cart.item_count;
        });
        trackNovaleEvent('novale_upsell_add', {
          source: form.closest('[data-novale-offer]') ? form.closest('[data-novale-offer]').dataset.offerSource : 'product_card',
          item_count: cart.item_count
        });

        button.textContent = 'Added';
        button.classList.add('is-added');
        if (feedback) feedback.textContent = 'Added to cart';

        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalLabel;
          button.classList.remove('is-added');
          if (feedback) feedback.textContent = '';
        }, 1800);
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Try again';
        if (feedback) feedback.textContent = 'Could not add this item.';
      });
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-quantity-input]');
    var form;
    var updateAction;
    var status;

    if (!input || input.disabled) return;

    form = input.closest('form');
    if (!form) return;

    updateAction = form.querySelector('input[name="update"][data-cart-auto-update]');
    if (!updateAction) {
      updateAction = document.createElement('input');
      updateAction.type = 'hidden';
      updateAction.name = 'update';
      updateAction.value = 'Update cart';
      updateAction.setAttribute('data-cart-auto-update', '');
      form.appendChild(updateAction);
    }

    status = form.querySelector('[data-cart-update-status]');
    input.readOnly = true;
    input.setAttribute('aria-busy', 'true');
    if (status) status.textContent = 'Updating cart...';
    window.setTimeout(function () {
      form.submit();
    }, 120);
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-bundle-add-all]');
    var variantIds;
    var items;
    var originalLabel;

    if (!button || button.disabled) return;

    variantIds = (button.dataset.bundleVariants || '').split(',').map(function (id) {
      return id.trim();
    }).filter(Boolean);
    if (!variantIds.length) return;

    originalLabel = button.textContent;
    items = variantIds.map(function (id) {
      return { id: Number(id), quantity: 1 };
    });
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch(rootPath() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to add bundle');
        return fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        toArray(document.querySelectorAll('[data-cart-count]')).forEach(function (count) {
          count.textContent = cart.item_count;
        });
        trackNovaleEvent('novale_bundle_add_all', { item_count: cart.item_count, variants: variantIds.length });
        button.textContent = 'Added';
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalLabel;
        }, 1800);
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = 'Try again';
      });
  });

  document.addEventListener('click', function (event) {
    var tier = event.target.closest('[data-quantity-tier]');
    var section;
    var quantity;
    var cap;
    var buttons;

    if (!tier) return;

    section = tier.closest('[data-product-section]');
    quantity = section && section.querySelector('input[name="quantity"]');
    cap = tier.closest('[data-quantity-tiers]') ? tier.closest('[data-quantity-tiers]').dataset.discountCap : '0';
    buttons = tier.closest('[data-quantity-tiers]').querySelectorAll('[data-quantity-tier]');

    if (quantity) quantity.value = tier.dataset.quantityTier;
    toArray(buttons).forEach(function (button) {
      button.classList.toggle('is-active', button === tier);
    });
    trackNovaleEvent('novale_quantity_tier_select', { quantity: tier.dataset.quantityTier, discount_cap: cap });
  });

  function formatMoney(cents) {
    var value = Number(cents || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(value);
    }
    return '$' + (value / 100).toFixed(2);
  }

  function fetchUpsellProduct(handle) {
    return fetch(rootPath() + 'products/' + encodeURIComponent(handle) + '.js', {
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Product not available');
      return response.json();
    });
  }

  function variantOptions(product) {
    return (product.variants || []).map(function (variant) {
      var disabled = variant.available ? '' : ' disabled';
      var label = variant.title === 'Default Title' ? product.title : variant.title;
      return '<option value="' + variant.id + '"' + disabled + '>' + escapeHtml(label) + (variant.available ? '' : ' - Sold out') + '</option>';
    }).join('');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  function offerCta(source) {
    if (source === 'buybox') return 'Add this too';
    if (source === 'cart') return 'Add to order';
    return 'Quick add';
  }

  function offerBadge(source, index) {
    if (source === 'buybox') return 'Best match';
    if (index === 0) return 'Top pick';
    return 'Recommended';
  }

  function renderMappedOffer(product, recommendation, source, index) {
    var image = product.featured_image || '';
    var firstAvailable = (product.variants || []).filter(function (variant) { return variant.available; })[0] || product.variants[0];
    var variantInput = '';
    var price = firstAvailable ? firstAvailable.price : product.price;
    var badgeMarkup = source === 'buybox' ? '' : '<span class="nv-upsell-card__badge">' + escapeHtml(offerBadge(source, index || 0)) + '</span>';

    if (!firstAvailable) return '';
    if (source === 'cart') return renderCartOffer(product, recommendation, index);

    if ((product.variants || []).length > 1) {
      variantInput = '<label class="visually-hidden" for="MappedUpsell-' + product.id + '-' + source + '">Choose ' + escapeHtml(product.title) + '</label><select id="MappedUpsell-' + product.id + '-' + source + '" name="id">' + variantOptions(product) + '</select>';
    } else {
      variantInput = '<input type="hidden" name="id" value="' + firstAvailable.id + '">';
    }

    return [
      '<article class="nv-upsell-card" data-novale-offer data-offer-source="' + escapeHtml(source) + '" data-offer-handle="' + escapeHtml(product.handle) + '">',
      '<a class="nv-upsell-card__image" href="' + rootPath() + 'products/' + escapeHtml(product.handle) + '">',
      image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '',
      '</a>',
      '<div class="nv-upsell-card__content">',
      badgeMarkup,
      '<a href="' + rootPath() + 'products/' + escapeHtml(product.handle) + '">' + escapeHtml(product.title) + '</a>',
      '<span class="nv-upsell-card__price">' + formatMoney(price) + '</span>',
      '<small>' + escapeHtml(recommendation.reason || 'Recommended add-on') + '</small>',
      '<form action="' + rootPath() + 'cart/add.js" method="post" enctype="multipart/form-data" class="nv-upsell-form" data-card-product-form data-offer-form>',
      variantInput,
      '<input type="hidden" name="quantity" value="1">',
      '<button type="submit" data-add-button>' + escapeHtml(offerCta(source)) + '</button>',
      '<span data-add-feedback role="status" aria-live="polite"></span>',
      '</form>',
      '</div>',
      '</article>'
    ].join('');
  }

  function availableVariant(product) {
    return (product.variants || []).filter(function (variant) { return variant.available; })[0] || product.variants[0];
  }

  function renderCartOffer(product, recommendation, index) {
    var image = product.featured_image || '';
    var firstAvailable = availableVariant(product);
    var variantInput = '';
    var price = firstAvailable ? firstAvailable.price : product.price;

    if (!firstAvailable) return '';

    if ((product.variants || []).length > 1) {
      variantInput = '<label class="visually-hidden" for="CartMappedUpsell-' + product.id + '">Choose ' + escapeHtml(product.title) + '</label><select id="CartMappedUpsell-' + product.id + '" name="id">' + variantOptions(product) + '</select>';
    } else {
      variantInput = '<input type="hidden" name="id" value="' + firstAvailable.id + '">';
    }

    return [
      '<article class="nv-cart-pick" data-novale-offer data-offer-source="cart" data-offer-handle="' + escapeHtml(product.handle) + '">',
      '<a class="nv-cart-pick__image" href="' + rootPath() + 'products/' + escapeHtml(product.handle) + '">',
      image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy">' : '',
      '</a>',
      '<div class="nv-cart-pick__copy">',
      '<span>' + escapeHtml(offerBadge('cart', index || 0)) + '</span>',
      '<a href="' + rootPath() + 'products/' + escapeHtml(product.handle) + '">' + escapeHtml(product.title) + '</a>',
      '<small>' + formatMoney(price) + ' - ' + escapeHtml(recommendation.reason || 'Recommended') + '</small>',
      '</div>',
      '<form action="' + rootPath() + 'cart/add.js" method="post" enctype="multipart/form-data" class="nv-cart-pick__form" data-card-product-form data-offer-form>',
      variantInput,
      '<input type="hidden" name="quantity" value="1">',
      '<button type="submit" class="nv-cart-pick__button" data-add-button>Add</button>',
      '<span data-add-feedback role="status" aria-live="polite"></span>',
      '</form>',
      '</article>'
    ].join('');
  }

  function renderCartBundle(products) {
    var bundleProducts = products.map(function (product) {
      return { product: product, variant: availableVariant(product) };
    }).filter(function (entry) {
      return entry.variant;
    }).slice(0, 2);
    var variants;
    var total;
    var itemsHtml;

    if (bundleProducts.length < 2) return '';

    variants = bundleProducts.map(function (entry) { return entry.variant.id; }).join(',');
    total = bundleProducts.reduce(function (sum, entry) {
      return sum + Number(entry.variant.price || entry.product.price || 0);
    }, 0);
    itemsHtml = bundleProducts.map(function (entry, index) {
      var image = entry.product.featured_image || '';
      return [
        index > 0 ? '<span class="nv-cart-bundle__plus" aria-hidden="true">+</span>' : '',
        '<a class="nv-cart-bundle__item" href="' + rootPath() + 'products/' + escapeHtml(entry.product.handle) + '" title="' + escapeHtml(entry.product.title) + '">',
        image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(entry.product.title) + '" loading="lazy">' : '',
        '</a>'
      ].join('');
    }).join('');

    return [
      '<div class="nv-cart-bundle__head">',
      '<span>Bundle pick</span>',
      '<strong>Add the matched set</strong>',
      '<small>' + bundleProducts.length + ' add-ons - ' + formatMoney(total) + '</small>',
      '</div>',
      '<div class="nv-cart-bundle__items">' + itemsHtml + '</div>',
      '<button type="button" class="nv-bundle-add-all" data-bundle-add-all data-bundle-variants="' + escapeHtml(variants) + '">Add all ' + bundleProducts.length + '</button>'
    ].join('');
  }

  function uniqueRecommendations(recommendations, excludedHandles, limit) {
    var seen = {};
    var output = [];

    recommendations.forEach(function (recommendation) {
      if (!recommendation || !recommendation.handle || seen[recommendation.handle] || excludedHandles[recommendation.handle]) return;
      seen[recommendation.handle] = true;
      output.push(recommendation);
    });

    return output.slice(0, limit);
  }

  function renderRecommendations(section, recommendations, source) {
    var grid = section.querySelector('[data-novale-upsell-grid]');
    if (!grid || !recommendations.length) return;

    Promise.all(recommendations.map(function (recommendation, index) {
      return fetchUpsellProduct(recommendation.handle)
        .then(function (product) {
          return {
            product: product,
            html: renderMappedOffer(product, recommendation, source, index)
          };
        })
        .catch(function () {
          return null;
        });
    })).then(function (cards) {
      var offers = cards.filter(function (card) { return card && card.html; });
      var html = offers.map(function (offer) { return offer.html; }).join('');
      var bundle;
      var bundleHtml;

      if (!html) return;

      if (source === 'cart') {
        bundle = section.querySelector('[data-novale-cart-bundle]');
        bundleHtml = renderCartBundle(offers.map(function (offer) { return offer.product; }));
        if (bundle && bundleHtml) {
          bundle.innerHTML = bundleHtml;
          bundle.hidden = false;
        }
      }

      grid.innerHTML = html;
      section.hidden = false;
      trackNovaleEvent('novale_upsell_impression', { source: source, offers: offers.length });
    });
  }

  function initProductUpsells() {
    var data = window.NovaleUpsells;
    var section = document.querySelector('[data-novale-product-upsells]');
    var buybox = document.querySelector('[data-novale-buybox-upsell]');
    var handle;
    var excluded = {};
    var recommendations;

    if (!data || (!section && !buybox)) return;

    handle = (section && section.dataset.productHandle) || (buybox && buybox.dataset.productHandle) || window.location.pathname.split('/products/')[1] || '';
    handle = handle.split(/[?#/]/)[0];
    if (!handle) return;

    excluded[handle] = true;
    recommendations = uniqueRecommendations(data.products[handle] || data.fallback || [], excluded, 3);
    if (buybox) renderRecommendations(buybox, recommendations.slice(0, 1), 'buybox');
    if (section) renderRecommendations(section, recommendations, 'product_page');
  }

  function initCartUpsells() {
    var data = window.NovaleUpsells;
    var section = document.querySelector('[data-novale-cart-upsells]');
    if (!data || !section) return;

    fetch(rootPath() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var excluded = {};
        var scored = {};
        var ranked = [];

        (cart.items || []).forEach(function (item) {
          var handle = item.handle || item.product_handle;
          if (!handle) return;
          excluded[handle] = true;
          (data.products[handle] || []).forEach(function (recommendation, index) {
            if (!recommendation || !recommendation.handle || excluded[recommendation.handle]) return;
            if (!scored[recommendation.handle]) {
              scored[recommendation.handle] = Object.assign({}, recommendation, { score: 0 });
            }
            scored[recommendation.handle].score += 10 - index + Number(recommendation.contributionProfit || 0);
          });
        });

        if (!Object.keys(scored).length) {
          ranked = uniqueRecommendations(data.fallback || [], excluded, 2);
        } else {
          ranked = Object.keys(scored).map(function (handle) { return scored[handle]; })
            .sort(function (a, b) { return b.score - a.score; })
            .slice(0, 2);
        }

        renderRecommendations(section, ranked, 'cart');
      })
      .catch(function () {});
  }

  initProductUpsells();
  initCartUpsells();

  toArray(document.querySelectorAll('[data-price-lock]')).forEach(function (lock) {
    var end = new Date(lock.dataset.priceLockEnd).getTime();
    var copy = lock.querySelector('[data-price-lock-copy]');

    if (!copy || Number.isNaN(end)) {
      lock.hidden = true;
      return;
    }

    function updatePriceLock() {
      var remaining = end - Date.now();
      var totalSeconds;
      var days;
      var hours;
      var minutes;
      var seconds;
      var prefix;

      if (remaining <= 0) {
        lock.hidden = true;
        return true;
      }

      totalSeconds = Math.floor(remaining / 1000);
      days = Math.floor(totalSeconds / 86400);
      hours = Math.floor((totalSeconds % 86400) / 3600);
      minutes = Math.floor((totalSeconds % 3600) / 60);
      seconds = totalSeconds % 60;
      prefix = days > 0 ? days + 'd ' : '';
      copy.textContent = prefix + pad2(hours) + ':' + pad2(minutes) + ':' + pad2(seconds) + ' remaining';
      return false;
    }

    if (!updatePriceLock()) {
      var timer = window.setInterval(function () {
        if (updatePriceLock()) window.clearInterval(timer);
      }, 1000);
    }
  });
})();
